import { Box, Image, Skeleton, VStack } from '@chakra-ui/react'
import AliceCarousel from 'react-alice-carousel'

export const NftImage = ({ imageUrl }: { imageUrl: string }) => (
  <Image
    borderRadius='1.875rem'
    src={imageUrl}
    objectFit='cover'
    w='100%'
    fallback={
      <Skeleton w='100%' minHeight={'300px'}>
        <Box
          w='30rem'
          maxWidth={['72%', '100%']}
          style={{ aspectRatio: '1 / 1' }}
        ></Box>
      </Skeleton>
    }
    transition={'transform .5s ease-in-out'}
    _hover={{
      transform: 'scale(1.05)',
    }}
  />
)

export const NftImageGallery = ({
  imageUrl,
  additionalImages,
}: {
  imageUrl: string
  additionalImages: { imageUrl: string }[]
}) => (
  <VStack justify='center' align='center'>
    <Box
      overflow={'hidden'}
      borderRadius='1.875rem'
      w='30rem'
      maxWidth={['72%', '100%']}
    >
      {additionalImages.length === 0 ? (
        <NftImage imageUrl={imageUrl}></NftImage>
      ) : (
        <AliceCarousel
          items={[imageUrl, ...additionalImages.map((img) => img.imageUrl)].map(
            (imageURLFromArr) => {
              return <NftImage imageUrl={imageURLFromArr}></NftImage>
            }
          )}
          mouseTracking
          touchTracking
          autoPlay
          infinite
          disableButtonsControls
          autoPlayInterval={4000}
        ></AliceCarousel>
      )}
    </Box>
  </VStack>
)